"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeSlideButton = exports.playingStateIcon = exports.headerWrapper = exports.wrapper = exports.root = void 0;

var _util = require("../../../util");

const borderSpace = '50px';

const root = ({
  cssProps
}) => ({
  position: 'relative',
  border: "".concat(borderSpace, " solid transparent"),
  zIndex: cssProps.zIndex || 'unset'
});

exports.root = root;

const wrapper = ({
  theme
}) => ({
  width: '360px',
  height: '639px',
  background: (0, _util.color)(theme, 'text.meta')
});

exports.wrapper = wrapper;

const headerWrapper = () => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  width: '100%',
  zIndex: 10
});

exports.headerWrapper = headerWrapper;

const playingStateIcon = ({
  cssProps,
  theme
}) => {
  const {
    isContentLoaded
  } = cssProps;
  return {
    color: (0, _util.color)(theme, 'text.3'),
    cursor: isContentLoaded ? 'pointer' : 'default'
  };
};

exports.playingStateIcon = playingStateIcon;

const changeSlideButton = ({
  cssProps
}) => {
  const {
    type
  } = cssProps;
  return {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    left: type === 'prev' ? "-".concat(borderSpace) : 'unset',
    right: type === 'next' ? "-".concat(borderSpace) : 'unset',
    cursor: 'pointer'
  };
};

exports.changeSlideButton = changeSlideButton;
//# sourceMappingURL=MediaStories.style.js.map